var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7A7C89",
    fillRule: "evenodd",
    d: "M4.14 0C1.855 0 0 1.854 0 4.14v7.813c0 2.287 1.854 4.14 4.14 4.14h.145C4.406 18.273 6.21 20 8.419 20h7.44C18.146 20 20 18.146 20 15.86V8.42c0-2.209-1.728-4.013-3.906-4.135v-.144C16.094 1.854 14.24 0 11.954 0H4.14zm11.954 6.323v5.63c0 2.287-1.854 4.14-4.14 4.14H6.321C6.44 17.15 7.333 17.97 8.42 17.97h7.44c1.165 0 2.11-.944 2.11-2.11V8.42c0-1.085-.82-1.98-1.875-2.096zM2.031 4.14c0-1.165.945-2.11 2.11-2.11h7.812c1.165 0 2.11.945 2.11 2.11v7.812c0 1.165-.945 2.11-2.11 2.11H4.141c-1.165 0-2.11-.945-2.11-2.11V4.141z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6378eac7.svg";
export { ForwardRef as ReactComponent };